import React, { useEffect, useState } from 'react'
import Modal from 'react-bootstrap/esm/Modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faXmark } from '@fortawesome/free-solid-svg-icons'

interface StartAssessmentModalProps {
  show: boolean
  contributorName?: string
  isSubmitting?: boolean
  onConfirm: (name: string) => void
  onCancel: () => void
}

const MAX_SESSION_NAME_LENGTH = 20

export function StartAssessmentModal({
  show,
  contributorName,
  isSubmitting = false,
  onConfirm,
  onCancel,
}: StartAssessmentModalProps) {
  const [name, setName] = useState('')
  const trimmedName = name.trim()
  const canSubmit = trimmedName.length > 0 && !isSubmitting

  useEffect(() => {
    if (show) {
      setName('')
    }
  }, [show])

  const handleConfirm = () => {
    if (!canSubmit) return
    onConfirm(trimmedName)
  }

  return (
    <Modal show={show} onHide={onCancel} centered>
      <div className="gw-mark-completed-modal">
        <div className="gw-mark-completed-header">
          <div className="gw-mark-completed-title-group">
            <div className="gw-mark-completed-icon gw-start-assessment-icon">
              <FontAwesomeIcon icon={faPlus} />
            </div>
            <h3 className="gw-mark-completed-title">Start New Assessment</h3>
          </div>
          <button
            type="button"
            onClick={onCancel}
            className="gw-mark-completed-close"
            aria-label="Close"
            disabled={isSubmitting}
          >
            <FontAwesomeIcon icon={faXmark} />
          </button>
        </div>

        <p className="gw-mark-completed-copy">
          Create a new assessment session
          {contributorName ? ` for ${contributorName}` : ''}. All competencies
          will start unscored.
        </p>

        <label className="gw-start-assessment-label" htmlFor="assessment-name">
          Session name
        </label>
        <input
          id="assessment-name"
          value={name}
          onChange={(event) => setName(event.target.value)}
          placeholder="e.g., Q2 2026"
          className="gw-start-assessment-input"
          maxLength={MAX_SESSION_NAME_LENGTH}
          autoFocus
          disabled={isSubmitting}
        />
        <div className="gw-start-assessment-count">
          {name.length}/{MAX_SESSION_NAME_LENGTH}
        </div>

        <div className="gw-mark-completed-actions">
          <button
            type="button"
            onClick={onCancel}
            className="gw-btn-cancel"
            disabled={isSubmitting}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={handleConfirm}
            className="gw-btn-submit"
            disabled={!canSubmit}
          >
            {isSubmitting ? 'Creating...' : 'Create Session'}
          </button>
        </div>
      </div>
    </Modal>
  )
}
